export const trickleDownPasses = (
  passes: Record<string, number>
): Record<number, number> => {
  // if something has 2 passes then it implictly has 1 pass (trickles down)
  // data from backend does not account for this
  const trickledDownPasses: Record<number, number> = {};
  for (const pass of Object.keys(passes)) {
    for (let i = parseInt(pass); i > 0; i--) {
      if (!(i in trickledDownPasses)) {
        trickledDownPasses[i] = 0;
      }
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      trickledDownPasses[i]! += passes[pass] ?? 0;
    }
  }
  return trickledDownPasses;
};
